<script setup lang="ts">
import { datadogLogs } from '@datadog/browser-logs'
const { error } = defineProps({
  error: Object,
})

interface StoryblokErrorItem {
  code: string
  title: string
  text: StoryBlokRichText
  image: StoryBlokImage
}

const storyblokApi = useStoryblokApiV2()
const isMenuOpen = ref(false)

const { stories } = await storyblokApi.getStories({
  by_slugs: ['layout/*'],
}) as any

const layoutData = {
  navigation: stories?.find((item: any) => item.slug === 'navigation'),
  footer: stories?.find((item: any) => item.slug === 'footer'),
  error: stories?.find((item: any) => item.slug === 'error'),
}

onMounted(() => {
  datadogLogs.logger.critical(`[${error.statusCode}] ${error.message}`, {}, error)
})

const errorItems = layoutData.error?.content?.items as StoryblokErrorItem[] || []
const errorItem = errorItems.find(item => Number(item.code) === error?.statusCode)
</script>

<template>
  <div>
    <TheNavigation v-model:is-menu-open="isMenuOpen" v-bind="layoutData?.navigation?.content" />
    <div class="flex pt-4 md:pt-10 flex flex-col relative from-background bg-gradient-to-b">
      <div class="px-5 z-1 flex flex-col md:text-center">
        <h1>{{ errorItem?.title || 'Nešpecifikovaná chyba' }}</h1>
        <StoryblokRichText :document="errorItem?.text" />
        <div class="sm:flex my-8 md:mt-4 md:mb-1">
          <StoryblokButton v-bind="layoutData?.error?.content?.homeButton[0]" class="<sm:mx-auto" />
        </div>
      </div>
      <div class="flex w-full justify-center">
        <div class="overflow-hidden z-1 pb-18 px-18 lg:px-0">
          <StoryblokImage v-if="errorItem?.image?.filename" :src="errorItem?.image" />
        </div>
      </div>
    </div>
    <TheFooter v-bind="layoutData?.footer?.content" />
  </div>
</template>
